import { noop } from 'lodash';
import { createContext } from 'use-context-selector';

import {
  BaseFieldOnBlurHandler,
  BaseFieldEnterKeyHint,
  BaseFieldOnFocusHandler,
  BaseFieldOnKeyUpHandler,
  BaseFieldOnKeyDownHandler,
  BaseFieldOnCompositionUpdateHandler,
} from '../Fields.types';
import { BaseFieldOnChangeHandler } from '../Fields.types';

import { MAX_DATE, MIN_DATE } from './FieldDatePicker.const';

interface FieldDatePickerContextProps {
  datetimeId: string;
  min: string;
  max: string;
  placeholder: string;
  invalid: boolean;
  error: string;
  onChange: BaseFieldOnChangeHandler<string>;
  value: string;
  onBlur: BaseFieldOnBlurHandler;
  enterKeyHint: BaseFieldEnterKeyHint;
  disabled: boolean;
  onFocus: BaseFieldOnFocusHandler;
  onKeyUp: BaseFieldOnKeyUpHandler;
  onKeyDown: BaseFieldOnKeyDownHandler;
  onCompositionUpdate: BaseFieldOnCompositionUpdateHandler;
}

export const FieldDatePickerContext =
  createContext<FieldDatePickerContextProps>({
    datetimeId: 'datetimeId',
    placeholder: '',
    min: MIN_DATE,
    max: MAX_DATE,
    invalid: false,
    error: '',
    onChange: noop,
    value: '',
    onBlur: noop,
    enterKeyHint: 'enter',
    disabled: false,
    onFocus: noop,
    onKeyUp: noop,
    onKeyDown: noop,
    onCompositionUpdate: noop,
  });
